import { ChevronDownIcon } from '@heroicons/react/solid';

const FaqItem = ({ question, answer, isOpen, onToggle }) => {
  return (
    <div className="mb-4 border-b border-gray-200">
      <button
        onClick={onToggle}
        className="w-full flex justify-between items-center py-4 text-left focus:outline-none transition-all duration-500"
      >
        <p className="text-lg font-semibold text-gray-800">
          {question}
        </p>
        <ChevronDownIcon
          className={`h-6 w-6 text-blue-500 transform transition-transform duration-500 ${
            isOpen ? 'rotate-180' : 'rotate-0'
          }`}
        />
      </button>
      <div
        className={`overflow-hidden transition-all duration-500 ${
          isOpen ? 'max-h-screen' : 'max-h-0'
        }`}
      >
        <p className="text-gray-600 text-base py-2">
          {answer}
        </p>
      </div>
    </div>
  );
};
export default FaqItem; 


